module.exports = __webpack_public_path__ + "img/avatar.44b4bbfa.png";